import React, {FC, memo} from 'react';
import {Price} from '../../../../types/Price';
import {PriceBoxProps} from '../PriceBox';
import {PriceTags} from './PriceTags';
import {Reductions} from './Reductions';

const ReductionsAndPriceTags: FC<
  Pick<
    PriceBoxProps,
    | 'hideReductions'
    | 'CountdownComponent'
    | 'align'
    | 'hideBadges'
    | 'reverseReductions'
  > & {price: Price}
> = props => {
  const hasReductions = Boolean(props.price.reductions?.length);
  const hasPriceTags = Boolean(props.price.priceTags?.length);

  if (props.hideReductions || (!hasReductions && !hasPriceTags)) {
    return null;
  }

  if (hasPriceTags) {
    return <PriceTags {...props} priceTags={props.price.priceTags} />;
  }

  return <Reductions {...props} />;
};

const MemoReductionsAndPriceTags = memo(ReductionsAndPriceTags);

export {MemoReductionsAndPriceTags as ReductionsAndPriceTags};
